import { Amount, HouseholdCreateArgs } from '@sky-distribution/adapter-core-pc-rest-interfaces';
import { BuyResponse } from '@sky-distribution/backend-gp-onboarding-interfaces';
import { getStaticVariants } from '../util/variants.config';
import {
  CreateResponse,
  Rating,
  Submission,
  SubmissionIds,
  UpdateResponse,
} from './Policy.service.type';
import mockRateResponse from './__mocks__/rate.mock.json';

export const MOCK_PAYMENT_URL = 'http://localhost:4001/zaplac';
export const MOCK_QUOTE_ID = '00000000-0000-0000-0000-000000012345';

class PolicyMockService {
  rate(rateData: unknown): Promise<{ ratings: Rating[] }> {
    console.info('REQUEST: PolicyMockService rate', rateData);

    return Promise.resolve(
      mockRateResponse as unknown as { ratings: Rating[] },
    );
  }

  create(quoteData: HouseholdCreateArgs): Promise<CreateResponse> {
    console.info('REQUEST: PolicyMockService create', quoteData);

    return Promise.resolve({
      data: {
        ...quoteData,
        baseData: {
          ...quoteData.baseData,
        },
        variants: getStaticVariants(),
      },
      ids: {
        jobUUID: MOCK_QUOTE_ID,
      },
    });
  }

  update(quoteData: Submission, ids: SubmissionIds): Promise<UpdateResponse> {
    console.info('REQUEST: PolicyMockService update', { data: quoteData, ids });

    return Promise.resolve({ data: quoteData, ids });
  }

  quote(quoteData: Submission, ids: SubmissionIds): Promise<UpdateResponse> {
    console.info('REQUEST: PolicyMockService quote', { data: quoteData, ids });

    return Promise.resolve({ data: quoteData, ids });
  }

  buy(
    arg: Submission,
    ids: SubmissionIds,
    productId: string,
    totalPrice?: Amount,
  ): Promise<BuyResponse> {
    console.info('REQUEST: PolicyMockService buy', arg, ids, productId, totalPrice);

    return Promise.resolve({
      paymentUrl: MOCK_PAYMENT_URL,
    });
  }
}

const policyMockService = new PolicyMockService();
export { policyMockService };
